import { DEFAULTS } from "./defaults.js";
import { nodeViewDecorators } from "./nodeViewDecorators/index.js";
import { LINK_TYPE } from "./types.js";
const pluginLink = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_TYPE,
    nodeViewDecorators
  };
};
export {
  pluginLink
};
//# sourceMappingURL=viewer-loadable.js.map
